import React, { useMemo, useState } from 'react';
import { GenericFieldWithErrorsProps } from './GenericFieldWithErrors';

import {
  PrimaryKey,
  SuggestionsPickerBase
} from '@cube3/main/src/components/app/layout/Contracts/prefabs/MultipleResourcePicker/SuggestionsPickerBase';
/* 
  optional:
  allowAddingOfNewSuggestions: Boolean to enable or disable adding of new suggestions. 
  suggestions: Array of suggestions.
  inputType: Input type.
  validator: Validator function used to validate input.

*/

interface MultipleSelectFieldProps extends GenericFieldWithErrorsProps {
  options?: string[];
  placeholder: string;
  validator?: (val: string) => string;
  allowAddingOfNewSuggestions?: boolean;
  primaryKey?: PrimaryKey;
  keysListeners?: string[];
}

const emptyArray = [];

function MultipleSelectField(props: MultipleSelectFieldProps) {
  const {
    //input,
    value = emptyArray,
    onChange,
    //
    placeholder = 'Start typing for suggestions',
    options = emptyArray,
    allowAddingOfNewSuggestions = true,
    validator,
    primaryKey,
    keysListeners = ['Tab', ',', ';', 'Enter']
  } = props;

  const [query, setQuery] = useState('');

  const suggestions = useMemo(() => {
    return options
      .filter(
        (opt: string) =>
          !value.find((v) => v.id === opt) &&
          (!query || opt.toLowerCase().includes(query.toLowerCase()))
      )
      .map((o) => ({ id: o, value: o }));
  }, [options, value, query]);

  return (
    <SuggestionsPickerBase
      query={query}
      setQuery={setQuery}
      suggestions={suggestions}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      primaryKey={primaryKey || 'id'}
      allowAddingOfNewSuggestions={allowAddingOfNewSuggestions}
      validator={validator}
      type={'string'}
      keysListeners={keysListeners}
    />
  );
}

export default MultipleSelectField;
